/*
 * Stallergenes Greer — Suche direkt im Kopf.
 *
 * WARUM ES DIESE DATEI GIBT:
 * Vorher führte die Lupe auf Shopifys Suchseite. Zwei Nachteile: ein
 * zusätzlicher Schritt, bevor man überhaupt tippen kann, und die
 * Trefferseite trägt Dawns Standardgestaltung - sie sieht aus wie ein
 * anderer Shop.
 *
 * Jetzt öffnet die Lupe ein Feld im Kopf. Getippt wird sofort, die Treffer
 * erscheinen darunter im Design des Shops und führen auf UNSERE Seiten -
 * nicht auf /products/..., wo Dawns Vorlage läge.
 *
 * Datenquelle ist Shopifys eigene Vorschlagssuche (/search/suggest.json).
 * Sie kennt Produkte UND Seiten, und sie trägt das Sprach-Präfix mit.
 */
(function () {
  'use strict';

  function sprache() {
    return (document.documentElement.getAttribute('lang') || 'de').slice(0, 2);
  }
  function wurzel() {
    return sprache() === 'de' ? '' : '/' + sprache();
  }

  var TEXT = {
    de: { platzhalter: 'Wonach suchen Sie?', nichts: 'Nichts gefunden.',
          produkte: 'Produkte', seiten: 'Seiten', ab: 'ab ' },
    fr: { platzhalter: 'Que cherchez-vous ?', nichts: 'Aucun résultat.',
          produkte: 'Produits', seiten: 'Pages', ab: 'dès ' }
  };
  function t(k) { return (TEXT[sprache()] || TEXT.de)[k]; }

  /* Shopify-Produkt -> unsere Produktseite. Ohne diese Zuordnung landet
     man auf /products/<handle> und damit in Dawns Standardvorlage. */
  function produktSeite(handle) {
    var m = window.SG_PRODUKTSEITE || {};
    var tab = m[sprache()] || m.de || {};
    return tab[handle] || null;
  }

  function panel() { return document.getElementById('sgsuche'); }
  function feld() { return document.getElementById('sgsuche-feld'); }
  function treffer() { return document.getElementById('sgsuche-treffer'); }

  window.sucheAuf = function () {
    var d = panel();
    if (!d) return;
    d.classList.remove('opacity-0', 'invisible');
    d.querySelector('.panel').classList.remove('-translate-y-3');
    var f = feld();
    if (f) {
      f.placeholder = t('platzhalter');
      setTimeout(function () { f.focus(); }, 60);
    }
  };

  window.sucheZu = function () {
    var d = panel();
    if (!d) return;
    d.classList.add('opacity-0', 'invisible');
    d.querySelector('.panel').classList.add('-translate-y-3');
  };

  function zeile(url, titel, unten, bild) {
    return '<a href="' + url + '" class="flex items-center gap-3 py-2.5 px-2 -mx-2 '
      + 'rounded-xl hover:bg-[var(--blue-mist)] transition">'
      + (bild ? '<img src="' + bild + '" alt="" class="w-11 h-11 rounded-lg object-cover shrink-0">'
              : '<span class="w-11 h-11 rounded-lg shrink-0" style="background:var(--paper-warm)"></span>')
      + '<span class="min-w-0"><span class="block font-700 text-[.92rem]">' + titel + '</span>'
      + (unten ? '<span class="block text-[.8rem]" style="color:var(--ink-soft)">' + unten
                 + '</span>' : '')
      + '</span></a>';
  }

  function gruppe(titel, inhalt) {
    if (!inhalt) return '';
    return '<div class="mb-3"><div class="kicker mb-2">' + titel + '</div>' + inhalt + '</div>';
  }

  function zeichnen(d) {
    var ziel = treffer();
    if (!ziel) return;
    var r = (d && d.resources && d.resources.results) || {};
    var produkte = (r.products || []).map(function (p) {
      var url = produktSeite(p.handle) || (wurzel() + p.url);
      var preis = p.price ? (t('ab') + p.price) : '';
      return zeile(url, p.title, preis, p.featured_image && p.featured_image.url);
    }).join('');
    var seiten = (r.pages || []).map(function (s) {
      return zeile(s.url, s.title, '', null);
    }).join('');

    if (!produkte && !seiten) {
      ziel.innerHTML = '<div class="py-6 text-center text-[.9rem]" '
                     + 'style="color:var(--ink-soft)">' + t('nichts') + '</div>';
      return;
    }
    ziel.innerHTML = gruppe(t('produkte'), produkte) + gruppe(t('seiten'), seiten);
  }

  var laeuft = null;

  function suchen(begriff) {
    if (!begriff || begriff.length < 2) {
      var z = treffer();
      if (z) z.innerHTML = '';
      return;
    }
    var url = wurzel() + '/search/suggest.json?q=' + encodeURIComponent(begriff)
            + '&resources[type]=product,page&resources[limit]=5';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(zeichnen)
      .catch(function (e) { console.error('[sg-suche]', e); });
  }

  function start() {
    var f = feld();
    if (!f) return;
    f.placeholder = t('platzhalter');
    f.addEventListener('input', function () {
      // Kurz warten, sonst schickt jeder Tastendruck eine Anfrage.
      clearTimeout(laeuft);
      var wert = f.value.trim();
      laeuft = setTimeout(function () { suchen(wert); }, 220);
    });
    f.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { window.sucheZu(); return; }
      if (e.key === 'Enter') {
        // Eingabetaste nimmt den ersten Treffer - eine eigene Trefferseite
        // gibt es bewusst nicht.
        e.preventDefault();
        var erste = treffer() && treffer().querySelector('a[href]');
        if (erste) window.location.href = erste.getAttribute('href');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') window.sucheZu();
    });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
